module.exports = __webpack_public_path__ + "static/media/A3.24bda5a8.png";